import {
  applicationPageClassName,
  applicationContentClassName,
} from "@client/components/applications/applicationLayout";
import { ApplicationHeader } from "./ApplicationHeader";
import { Page } from "@client/components/utils/Page";
import { Skeleton } from "@sfc/ui";

/** Keep loading content in the same page shell as the loaded content. */
export function ApplicationLoading({
  label = "Loading application",
  rows = 3,
  layout = "list",
}: {
  label?: string;
  rows?: number;
  layout?: "list" | "directory" | "questions";
}) {
  return (
    <div role="status" aria-label={label} className="space-y-4">
      <div
        aria-hidden="true"
        className={
          layout === "directory" ? "@container space-y-3" : "space-y-4"
        }
      >
        {Array.from({ length: rows }, (_, index) => (
          <div
            key={index}
            className={
              layout === "questions"
                ? "space-y-3 border-b border-border py-4"
                : layout === "directory"
                  ? "flex flex-col gap-4 rounded-lg border border-border bg-card p-5 @lg:flex-row @lg:items-center @lg:justify-between @lg:p-6"
                  : "space-y-3 rounded-lg border border-border bg-card p-5"
            }
          >
            {layout === "directory" ? (
              <>
                <div className="min-w-0 space-y-2">
                  <Skeleton className="h-6 w-48 max-w-full motion-reduce:animate-none" />
                  <Skeleton className="h-4 w-36 max-w-full motion-reduce:animate-none" />
                </div>
                <Skeleton className="h-11 w-full motion-reduce:animate-none @lg:w-44" />
              </>
            ) : (
              <>
                <Skeleton className="h-5 w-2/3 motion-reduce:animate-none" />
                <Skeleton className="h-4 w-1/3 motion-reduce:animate-none" />
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export function SavedApplicationLoading({
  editing = false,
}: {
  editing?: boolean;
}) {
  return (
    <Page
      spacing="compact"
      containerClassName={applicationPageClassName}
      className="space-y-6"
    >
      <ApplicationHeader backLabel={editing ? "Application details" : "Home"} />
      <div className={applicationContentClassName}>
        <ApplicationLoading layout="questions" />
      </div>
    </Page>
  );
}
